import { getDatabase } from '../data/db'
import { assertWorkspaceActive } from '../data/workspace'
import type { ActiveDraft } from '../domain/note'
const adoptionKey = (id: string) => `share-target:adopted:${id}`
export async function wasShareAdopted(id: string): Promise<boolean> {
  return Boolean(await (await getDatabase()).get('meta', adoptionKey(id)))
}
/** The durable draft and replay marker commit together before the inbox is acknowledged. */
export async function commitSharedDraft(id: string, draft: ActiveDraft): Promise<void> {
  const database = await getDatabase()
  assertWorkspaceActive()
  const tx = database.transaction(['drafts', 'meta'], 'readwrite')
  await tx.objectStore('drafts').put(draft)
  await tx.objectStore('meta').put({ key: adoptionKey(id), value: 'complete' })
  await tx.done
}
